import { defineMessages } from 'react-intl';

import { carouselMessages } from '@package/customization-messages';

const originalMessages = defineMessages({
  Source: {
    id: 'Source',
    defaultMessage: 'Source',
  },
  Carousel: {
    id: 'Carousel',
    defaultMessage: 'Carousel',
  },
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  description: {
    id: 'Description',
    defaultMessage: 'Description',
  },
  imageOverride: {
    id: 'Image override',
    defaultMessage: 'Image override',
  },
  item: {
    id: 'Item',
    defaultMessage: 'Item',
  },
  items: {
    id: 'Items',
    defaultMessage: 'Items',
  },
  addItem: {
    id: 'Add item',
    defaultMessage: 'Add item',
  },
  headline: {
    id: 'Headline',
    defaultMessage: 'Headline',
  },
  itemsToShow: {
    id: 'Items to show',
    defaultMessage: 'Items to show',
  },
  hideDescription: {
    id: 'Hide description',
    defaultMessage: 'Hide description',
  },
  settings: {
    id: 'Settings',
    defaultMessage: 'Settings',
  },
  textBelow: {
    id: 'Text Below',
    defaultMessage: 'Text Below',
  },
  textInner: {
    id: 'Text Inner',
    defaultMessage: 'Text Inner',
  },
});

const messages = {
  ...originalMessages,
  ...carouselMessages,
};

const itemSchema = (props) => {
  const { intl } = props;

  return {
    title: intl.formatMessage(messages.item),
    addMessage: intl.formatMessage(messages.addItem),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['href', 'title', 'description', 'preview_image'],
      },
    ],

    properties: {
      href: {
        title: intl.formatMessage(messages.Source),
        widget: 'object_browser',
        mode: 'link',
        selectedItemAttrs: ['Title', 'Description', 'image_field'],
        allowExternals: true,
      },
      title: {
        title: intl.formatMessage(messages.title),
      },
      description: {
        title: intl.formatMessage(messages.description),
        widget: 'textarea',
      },
      preview_image: {
        title: intl.formatMessage(messages.imageOverride),
        widget: 'object_browser',
        mode: 'image',
        allowExternals: true,
      },
    },
    required: [],
  };
};

export const carouselSchema = (props) => {
  const { intl, data = {} } = props;

  const aspectRatioChoices = [
    ['100%', '1/1'],
    ['66.6666%', '3/2'],
    ['75%', '4/3'],
    ['56.25%', '16/9'],
    ['50%', '2/1'],
    ['33.3333%', '3/1'],
    ['125%', '4/5'],
    ['120%', '5/6'],
    ['150%', '3/4'],
    ['177.78%', '9/16'],
  ];

  return {
    title: props.intl.formatMessage(messages.Carousel),
    block: 'carousel',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['columns'],
      },
      {
        id: 'settings',
        title: props.intl.formatMessage(messages.settings),
        fields: [
          'headline',
          'items_to_show',
          'hide_description',
          'layout',
          'aspectRatioDesktop',
          'aspectRatioMobile',
          'infinite',
          'autoplay',
          'autoplaySpeed',
        ],
      },
    ],
    properties: {
      columns: {
        widget: 'object_list',
        title: props.intl.formatMessage(messages.items),
        schema: itemSchema,
      },
      headline: {
        title: props.intl.formatMessage(messages.headline),
      },
      items_to_show: {
        type: 'number',
        title: props.intl.formatMessage(messages.itemsToShow),
        default: 1,
      },
      hide_description: {
        title: props.intl.formatMessage(messages.hideDescription),
        type: 'boolean',
      },
      infinite: {
        title: intl.formatMessage(messages.infinite),
        description: intl.formatMessage(messages.infiniteDesc),
        type: 'boolean',
      },
      autoplay: {
        title: intl.formatMessage(messages.autoplay),
        type: 'boolean',
      },
      autoplaySpeed: {
        title: intl.formatMessage(messages.autoplaySpeed),
        description: intl.formatMessage(messages.autoplaySpeedDesc),
        type: 'number',
        default: 6,
        isDisabled: !data.autoplay,
      },
      layout: {
        title: intl.formatMessage(messages.layout),
        required: true,
        noValueOption: false,
        default: 'c-default',
        type: 'string',
        factory: 'Choice',
        choices: [
          ['c-default', intl.formatMessage(messages.textBelow)],
          ['back', intl.formatMessage(messages.textInner)],
        ],
      },
      aspectRatioDesktop: {
        title: intl.formatMessage(messages.aspectRatioDesktop),
        required: true,
        noValueOption: false,
        default: '66.6666%',
        type: 'string',
        factory: 'Choice',
        choices: aspectRatioChoices,
      },
      aspectRatioMobile: {
        title: intl.formatMessage(messages.aspectRatioMobile),
        required: true,
        noValueOption: false,
        default: '66.6666%',
        type: 'string',
        factory: 'Choice',
        choices: aspectRatioChoices,
      },
    },
    required: [],
  };
};
